<template>
    <div class="text-center pt-5">
        <h3>
          403 - Du har inte rättighet att visa denna sida
        </h3>
    </div>
</template>

<script>
export default {
    name: 'Forbidden',
};
</script>
